import React from "react";

const HOST_IMG =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const INTERIOR =
  "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&w=1600";
const DINING =
  "https://images.unsplash.com/photo-1760533536699-85be9a478652?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="overline mb-4">About</p>
        <h1 className="font-serif-luxe text-6xl md:text-8xl leading-none tracking-tighter max-w-4xl">
          A collection built one <span className="italic text-[#D4AF37]">key</span> at a time.
        </h1>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={HOST_IMG} alt="Your host" className="w-full h-full object-cover" />
            </div>
            <p className="mt-4 text-xs text-[#737373] uppercase tracking-[0.2em]">
              Your host — VacayStay Rentals
            </p>
          </div>
          <div className="md:col-span-6 md:col-start-7 space-y-8">
            <p className="text-lg text-[#F5F5DC]/90 leading-relaxed">
              I never set out to build a rental business. I set out to keep the
              homes I loved feeling loved — full of guests who came for a slow
              week and left with a story.
            </p>
            <p className="text-lg text-[#F5F5DC]/80 leading-relaxed">
              Every property in this collection is one I've walked through
              personally. I know the way the morning light hits the pool at
              Villa Aurelia. I know the exact espresso beans stocked at Maison
              du Lac. I know which drawer holds the tide charts at Casa Serena.
            </p>
            <p className="text-lg text-[#F5F5DC]/80 leading-relaxed">
              When you book with me, you book with me. No agency. No corporate
              inbox. Just a direct line, a fair price, and the quiet confidence
              that someone actually cares whether your stay is good.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mt-32 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { n: "01", t: "Direct booking", d: "No platforms, no service fees, no algorithm deciding what you see." },
            { n: "02", t: "Editorial standard", d: "Every home meets a boutique-hotel bar for design, linens, and comfort." },
            { n: "03", t: "Real hospitality", d: "You'll hear from me — usually within a few hours, always personally." },
          ].map((v) => (
            <div key={v.n} className="border-t border-[#F5F5DC]/10 pt-8">
              <p className="font-serif-luxe text-4xl text-[#D4AF37]">{v.n}</p>
              <h4 className="font-serif-luxe text-2xl mt-4">{v.t}</h4>
              <p className="mt-3 text-[#A3A3A3] leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        {/* Image row */}
        <div className="mt-32 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={INTERIOR} alt="" className="w-full h-full object-cover" />
          </div>
          <div className="aspect-[4/5] overflow-hidden mt-0 md:mt-16">
            <img src={DINING} alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
}
